<template>
  <div >
    <router-view></router-view>
    <index-card :loading="loading">
      <template slot="header">
        <div class="d-flex align-center">
          <v-btn text icon large to="/" exact><v-icon class="white--text">mdi-arrow-left</v-icon></v-btn>
        </div>
        <div class="d-flex align-center">
          <span class="headline white--text">
            Local de Retira
          </span>
          <v-btn text icon @click="getPickupLocations()" exact><v-icon class="white--text">mdi-refresh</v-icon></v-btn>
        </div>
      </template>
      <template slot="subheader">
        <div class="pickup-locations-filters">
          <filter-data
            :with_client="false"
            :with_date_start="false"
            :with_date_end="false"
            with_text_search
            text_search_label="Pesquise.."
            :loading_block="loading"
            @doneFilter="handleDoneFilter"
          />
        </div>
      </template>
      <template slot="data_table">
        <v-data-table :headers="headers" :items="pickup_locations"
          class="elevation-4" :search="search" v-if="!loading" mobile-breakpoint="1">
          <template v-slot:item.actions="{item}">
            <div class="d-flex justify-center align-center">
              <v-btn @click="showPickupLocation(item)" small icon class="primary">
                <v-icon class="white--text" small>mdi-pencil</v-icon>
              </v-btn>
            </div>
          </template>
        </v-data-table>
      </template>
    </index-card>
  </div>
</template>

<script>
import Api from '@/api/index';

export default {
  name: 'PickupLocations',
  components:{
    IndexCard: () => import("@/_backoffice/_registrations/components/shared/index/IndexCard.vue"),
    SelectOneClient: () => import("@/_backoffice/_financial/components/shared/SelectOneClient.vue"),
    FilterData: () => import('@/components/shared/FilterData.vue'),
  },
  data() {
    return {
      loading: false,
      search: '',
      pickup_locations: [],
      local_filter: {
        index_serializer: true
      },
      headers: [
        { text: 'Nome', value: 'attributes.name', align: 'center' },
        { text: 'CNPJ', value: 'attributes.CNPJ', align: 'center' },
        { text: 'Endereço', value: 'attributes.full_address', align: 'center' },
        { text: 'Marca', value: 'attributes.brand_name', align: 'center' },
        { text: 'Paletes', value: 'attributes.quantity_of_pallets', align: 'center' },
        { text: 'Ações', value: 'actions', align: 'center' },
      ],
    }
  },
  methods: {
    getData(){
      this.getPickupLocations()
    },
    handleDoneFilter(filter = {}) {
      this.search = filter.query ? String(filter.query) : ''
    },
    getPickupLocations(){
      this.loading = true
      this.pickup_locations = []
      Api.PickupLocation.index(this.local_filter).then((res)=>{
        this.pickup_locations  = [...res.data.data]
      }).finally(()=>{
        this.loading = false
      })
    },
    handleChangeClient(client_id){
      this.local_filter.client_id = client_id
      this.getPickupLocations()
    },
    showPickupLocation(building){
      this.$router.push({name: "ShowPickupLocation", params:{ id: building.id }})
    },
  },
  mounted() {
    this.getData()
  },
}
</script>

<style scoped>
.pickup-locations-filters {
  width: 100%;
  flex: 1 1 100%;
  min-width: 0;
}
.pickup-locations-filters >>> .filter-data-card {
  width: 100%;
}
</style>